import { platformIconMap } from 'root/src/shared/constants/dropKeys';
import * as RewardCard from 'root/src/client/web/giveaway/components/RewardCard';
import { useGiveawayRewards } from 'root/src/client/web/giveaway/features/GiveawayRewards/hooks/useGiveawayRewards';
import classnames from 'classnames';
import Autoplay from 'embla-carousel-autoplay';
import { memo, useCallback } from 'react';
import { RewardForValue } from 'root/src/shared/constants/dropEvent';
import { UpdatePoolButton } from 'root/src/client/web/giveaway/features/GiveawayRewards/UpdatePoolButton';
import { useCreatorDataInfo } from 'root/src/client/web/record/CreatorData/hooks/useCreatorDataInfo';
import InfoIcon from '@mui/icons-material/Info';
import { BaseTooltip, BaseTooltipContent, } from 'root/src/client/v2/common/components/BaseTooltip/BaseTooltip';
import { RewardsCarousel } from 'root/src/client/web/giveaway/components/RewardsCarousel/RewardsCarousel';
export const GiveawayRewards = memo(() => {
    const { rewards } = useGiveawayRewards();
    const { isOwnProfile } = useCreatorDataInfo();
    const renderReward = useCallback((reward) => (<div className="h-96 w-full break-all flex flex-initial relative items-center justify-center select-none">
				<Reward reward={reward}/>
			</div>), []);
    // means user has no rewards available
    if (!(rewards === null || rewards === void 0 ? void 0 : rewards.length))
        return null;
    return (<div className="flex flex-col gap-5">
			<TitleGiveawayRewards />
			<div className="flex justify-center items-center w-full">
				<RewardsCarousel rewards={rewards} renderReward={renderReward} loop={!isOwnProfile} plugins={!isOwnProfile
            ? [
                Autoplay({
                    delay: 5000,
                    stopOnInteraction: false,
                }),
            ]
            : []} containerClassName={isOwnProfile ? 'pt-[15px]' : 'py-4'} slideClassName="flex-[0_0_40%] md:flex-[0_0_20%] flex justify-center items-center"/>
			</div>
		</div>);
});
const TitleGiveawayRewards = () => {
    const { rewards } = useGiveawayRewards();
    const { isOwnProfile } = useCreatorDataInfo();
    if (!isOwnProfile) {
        return (<p className="uppercase text-xs text-light-4 mx-4">
				Rewards in the Giveaway Loop
			</p>);
    }
    const inLoopRewardsCount = rewards.filter(reward => reward.rewardFor === RewardForValue.FANS).length;
    return (<div className="flex items-center gap-1">
			<BaseTooltip tooltip={(<BaseTooltipContent>
						Hidden rewards are visible only to you
					</BaseTooltipContent>)}>
				<InfoIcon />
			</BaseTooltip>
			<p className="uppercase text-xs text-light-4 mt-[2px]">
				Rewards in the Giveaway Loop ({inLoopRewardsCount} / {rewards.length})
			</p>
		</div>);
};
export const Reward = memo(({ reward }) => {
    const region = 'region' in reward ? `(${reward.region})` : '';
    const isDisabled = reward.isClaimed || reward.rewardFor !== RewardForValue.FANS;
    const { isOwnProfile } = useCreatorDataInfo();
    return (<RewardCard.Root className={classnames('h-full border-2 relative', isDisabled ? 'border-gray-1' : 'border-teal')} key={reward.fullId}>
			{reward.isClaimed && <RewardCard.ClaimedLabel />}
			{!reward.isClaimed && isOwnProfile && (<UpdatePoolButton rewardId={reward.id} rewardFor={reward.rewardFor} available={reward.available}/>)}
			<RewardCard.AvailableBadge available={reward.available}/>
			<RewardCard.ImageContainer className={classnames(isDisabled ? 'border-gray-1' : '')}>
				<RewardCard.GameImage src={reward.image} alt={reward.name}/>
			</RewardCard.ImageContainer>
			<RewardCard.GameTitle className="mt-2" title={reward.name}/>
			<RewardCard.Details>
				<RewardCard.RewardTitle className={classnames(isDisabled ? 'text-gray-1' : '')}>
					{reward.name} code{' '}
					<span className="capitalize text-inherit">{region}</span>
				</RewardCard.RewardTitle>
				{typeof reward.platform === 'string' && (<RewardCard.PlatformIcon icon={platformIconMap[reward.platform]}/>)}
				{reward.restrictions && (<RewardCard.RewardRestrictions>
						{reward.restrictions}
					</RewardCard.RewardRestrictions>)}
			</RewardCard.Details>
		</RewardCard.Root>);
});
